import './clientTimeline.less';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import {openModal} from '../../actions/ModalActions';
import {loadClientEvents, qualifyClient} from '../../actions/ClientActions';
import CreateContactModal from '../CreateContactModal';
import InfiniteScroll from '../InfiniteScroll';
import groupByDate from '../../utils/groupByDate';
import TimelineItemContainer from './TimelineItemContainer';

var canLoadMoreEvents = (paginationData) => {
    return paginationData.numPages > paginationData.currentPage;
};

@connect(
    state => ({
        isLoaded: state.activeClient.loaded,
        client: state.activeClient.client,
        contacts: state.activeClient.contacts,
        events: state.activeClient.events,
        eventsPaginationData: state.activeClient.eventsPaginationData,
        employees: state.users.users,
    }),
    { loadClientEvents, openModal, qualifyClient }
)
export default class ClientTimeline extends React.Component {

    constructor(props){
        super(props);

        var employees = this.props.employees
            .map(e => ({
                id: e.id,
                fullName: e.firstName + " " + e.lastName,
                avatarUrl: e.image
            }));

        this.state = {
            showNotes : true,
            showCalls : true,
            showMeetings : true,
            showEmails : true,
            showActivity : true,
            showUserVoice : true,
            hideIndustryPicker : false,
            assignedEmployees: [],
            employees: employees
        }
    }

    sortDates(a, b){ 
        return moment(b.date).diff(moment(a.date), 'seconds');
    }

    showCreateContactModal() {
        this.props.openModal(CreateContactModal, {clientId: this.props.client.id});
    }

    getTimeLineItemFromEvent(event) {
        var props = event;
        props.event = event;

        return React.createElement(TimelineItemContainer, props);
    }

    loadMoreEvents() {
        return this.loadEventsForPage(this.props.eventsPaginationData.currentPage + 1, true);
    }

    loadEventsForPage(page) {

        var data = {
            page: page, 
            showNotes : this.state.showNotes,
            showMeetings : this.state.showMeetings,
            showCalls : this.state.showCalls,
            showEmails : this.state.showEmails,
            showActivity : this.state.showActivity,
            showUserVoice : this.state.showUserVoice
        };

        return this.props.loadClientEvents(this.props.client.id, data);
    }

    toggleFilter(filterType){

        var newState = {};
        newState['show' + filterType] = ! this.state['show' + filterType];

        this.setState(newState, () => {
            this.loadEventsForPage(1, false)            
        });        
    }

    handleIndustryChange(value){
        this.setState({
            industryName : value
        });
    }

    handleEmployeeSelected(selected){
        var assignedEmployees = this.state.assignedEmployees;
        assignedEmployees.push(selected);

        this.setState({assignedEmployees: assignedEmployees});
    }

    handleEmployeeDeselected(selected){
        var assignedEmployees = this.state.assignedEmployees.filter(e => e.id != selected.id);
        this.setState({assignedEmployees: assignedEmployees});
    }

    saveIndustryChange(){
         this.props.qualifyClient({
            clientId : this.props.client.id,
            industryName : this.state.industryName,
            reportedStaffCount : false        
        });

        this.setState({
            hideIndustryPicker : true
        });
    }

    render() {
        var { eventsPaginationData } = this.props;

        var eventsByDate = groupByDate(this.props.events);

		//var haveDoneFutureChangeover = false;
		var haveDoneNextMonth = false;
		var haveDoneNextWeek = false;
		var haveDoneYesterday = false;
		var haveDoneToday = false;
		var haveDoneTomorrow = false;
		var haveDoneLastWeek = false;
		var haveDoneLastMonth = false;

        return (
            <div className="clientTimeline clientTimeline__component">                
                <div className="clientTimeline__filters">
                    <strong>Filters:</strong>
                    <div>
                        <button className={"btn btn-sm " + (this.state.showNotes ? 'active' : '')}  onClick={this.toggleFilter.bind(this, 'Notes')}>
                            <i className={"fa " + (this.state.showNotes ? "fa-check" : "fa-square")}></i> Notes
                        </button>
                        <button className={"btn btn-sm " + (this.state.showMeetings ? 'active' : '')}  onClick={this.toggleFilter.bind(this, 'Meetings')}>
                            <i className={"fa " + (this.state.showMeetings ? "fa-check" : "fa-square")}></i> Meetings
                        </button>
                        <button className={"btn btn-sm " + (this.state.showMeetings ? 'active' : '')}  onClick={this.toggleFilter.bind(this, 'Calls')}>
                            <i className={"fa " + (this.state.showCalls ? "fa-check" : "fa-square")}></i> Calls
                        </button>
                        <button className={"btn btn-sm " + (this.state.showEmails ? 'active' : '')}  onClick={this.toggleFilter.bind(this, 'Emails')}>
                            <i className={"fa " + (this.state.showEmails ? "fa-check" : "fa-square")}></i> Emails
                        </button>
                        <button className={"btn btn-sm " + (this.state.showActivity ? 'active' : '')}  onClick={this.toggleFilter.bind(this, 'Activity')}>
                            <i className={"fa " + (this.state.showActivity ? "fa-check" : "fa-square")}></i> Activity
                        </button>
                        <button className={"btn btn-sm " + (this.state.showUserVoice ? 'active' : '')}  onClick={this.toggleFilter.bind(this, 'UserVoice')}>
                            <i className={"fa " + (this.state.showUserVoice ? "fa-check" : "fa-square")}></i> User Voice
                        </button>
                    </div>
                </div>

                <InfiniteScroll hasMore={canLoadMoreEvents(eventsPaginationData)} loadMore={this.loadMoreEvents.bind(this)}>
                    <div className="clientTimeline__timeline">
                        {! this.props.events.length &&
                            <h2 style={{marginLeft : '20px'}}>No timeline events for this client</h2>
                        }

                        {eventsByDate.map((eventsForDate, i) => {
                            var date = moment( eventsForDate[0].date );
                            var today = moment();
                            var currentDateisFuture = today.diff(date, 'days') <= 0;

                            var dayLabel = date.format('MMM Do YYYY');
							var dateLabel = null;


							if(currentDateisFuture){
								if(!haveDoneTomorrow && date.isSame(moment().add(1, 'day'), 'day')){
									dateLabel = "Tomorrow";
									haveDoneTomorrow = true;
								}else if(!haveDoneNextWeek && date.isSame(moment().add(1, 'week'), 'week')){
									dateLabel = "Next Week";
									haveDoneNextWeek = true;
								}else if(!haveDoneNextMonth && date.isSame(moment().add(1, 'month'), 'month')){
									dateLabel = "Next Month";
									haveDoneNextMonth = true;
								}else if(!haveDoneToday && date.isSame(moment(), "day")){
									dateLabel = "Today";
									haveDoneToday = true;
								} 
							}else{
								if(!haveDoneYesterday && date.isSame(moment().subtract(1, 'day'), "day")){
									dateLabel = "Yesterday";
									haveDoneYesterday = true;
								} else if(!haveDoneLastWeek && date.isSame(moment().subtract(1, 'week'), "week")){
									dateLabel = "Last Week";
									haveDoneLastWeek = true;
								} else if(!haveDoneLastMonth && date.isSame(moment().subtract(1, 'month'), "month")){
									dateLabel = "Last Month";
									haveDoneLastMonth= true;
								}
							}


							//var nextDateGroup = eventsByDate[i + 1];

							//var doFutureChangeover = false;
							//if (! haveDoneFutureChangeover){
                            //    var nextDate = false;
                            //    if (nextDateGroup){
                            //        nextDate = moment(nextDateGroup[0].date);
                            //    }
                            //    var nextDateIsFuture = nextDate && today.diff(nextDate, 'days') <= 0;
                            //    doFutureChangeover = (currentDateisFuture && ! nextDateIsFuture);

                            //    if (doFutureChangeover){
                            //        haveDoneFutureChangeover = true;
                            //    }
                            //}

                            return (
								<div key={i}>
									{dateLabel && <h2 className="clientTimeline__dateLabel">{dateLabel}</h2>}
									<div className="clientTimeline__event">
										<div className="clientTimeline__dayLabel"><h2>{ dayLabel }</h2></div>
										{eventsForDate.sort(this.sortDates).map((event,i) => {
											var className = event.newlyAdded ? " fade-in" : '';
											return (
												<div className={className} key={`${date.format("YYYY-MM-DD")}${i}`}>
													{this.getTimeLineItemFromEvent(event)}
												</div>
											);
										})}
									</div>
								</div>
                            );
                        })}
                    </div>
                </InfiniteScroll>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/client-timeline/ClientTimeline.js